






import Vue from 'vue'

export default Vue.extend({
  props: {
    count: {
      type: Number,
      default: 5,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timers: [] as number[],
    }
  },
  computed: {
    dotsArray(): number[] {
      return Array.from({ length: this.count }).map((_, i) => i)
    },
  },
  watch: {
    value() {
      this.applyValue()
    },
  },
  mounted() {
    setTimeout(() => {
      this.applyValue()
    }, 0)
  },
  methods: {
    applyValue(): void {
      const $dots = this.$refs.dots as HTMLDivElement

      if (!$dots) return

      this.timers.forEach((timerId) => clearTimeout(timerId))
      this.timers = []

      const dotElements = [].slice.call($dots.children) as HTMLDivElement[]

      dotElements.forEach(($dot, i) => {
        $dot.classList.remove('filled')
        const timerId = setTimeout(() => {
          if (this.value > i) {
            $dot.classList.add('filled')
            this.timers = this.timers.filter((t) => t !== timerId)
          }
        }, 200 * i + 1)

        this.timers = [...this.timers, timerId]
      })
    },
  },
})
